import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getValue, PaymentMethodsCommandNames, SharedCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { Component } from '../../../constants/CallbackConstants';
import { ERRORS } from '../../../constants/Errors';
import { doFireStatusUpdate } from '../../../utils/CallbackUtils';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
import { updatePricingCommand } from './updatePricingCommand';
import { fetchPaymentMethodCommand } from './fetchPaymentMethodCommand';
import { selectedMopViewCommand } from './selectedMopViewCommand';
import { resetFieldsCommand } from './resetFieldsCommand';
import { reauthorizeCommand } from './reauthorizeCommand';
import { openBilldeskCommand } from './openBilldeskCommand';
/**
 * Payment methods commands handler
 * @param state
 * @param commands
 * @param dispatch
 */
export var loopCommands = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state, commands, dispatch) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return asyncForEach(commands, /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(command) {
              var commandName;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    commandName = getValue(command, 'commandName');
                    _context.t0 = commandName;
                    _context.next = _context.t0 === SharedCommandNames.UPDATE_PRICING ? 4 : _context.t0 === PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD ? 5 : _context.t0 === PaymentMethodsCommandNames.SELECTED_MOP_VIEW ? 6 : _context.t0 === PaymentMethodsCommandNames.RESET_FIELDS ? 7 : _context.t0 === SharedCommandNames.REAUTHORIZE ? 8 : _context.t0 === PaymentMethodsCommandNames.OPEN_BILLDESK ? 9 : 10;
                    break;
                  case 4:
                    return _context.abrupt("return", updatePricingCommand({
                      state: state,
                      command: command,
                      dispatch: dispatch
                    }));
                  case 5:
                    return _context.abrupt("return", fetchPaymentMethodCommand({
                      state: state,
                      command: command,
                      dispatch: dispatch
                    }));
                  case 6:
                    return _context.abrupt("return", selectedMopViewCommand({
                      state: state,
                      command: command,
                      dispatch: dispatch
                    }));
                  case 7:
                    return _context.abrupt("return", resetFieldsCommand({
                      state: state,
                      command: command,
                      dispatch: dispatch
                    }));
                  case 8:
                    return _context.abrupt("return", reauthorizeCommand({
                      state: state,
                      command: command,
                      dispatch: dispatch
                    }));
                  case 9:
                    return _context.abrupt("return", openBilldeskCommand({
                      state: state,
                      command: command,
                      dispatch: dispatch
                    }));
                  case 10:
                    sendNewRelicMessage("Unsupported Command: ".concat(commandName));
                    doFireStatusUpdate([{
                      status: StatusTypes.ERROR,
                      command: SharedCommandNames.UNKNOWN_CALLBACK,
                      payload: {
                        component: Component.EXECUTE_COMMAND_LOGIC,
                        errors: [_objectSpread(_objectSpread({}, ERRORS.UNSUPPORTED_COMMAND), {}, {
                          message: "Unsupported Command: ".concat(commandName)
                        })]
                      }
                    }]);
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x4) {
              return _ref2.apply(this, arguments);
            };
          }());
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function loopCommands(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
function asyncForEach(_x5, _x6) {
  return _asyncForEach.apply(this, arguments);
}
function _asyncForEach() {
  _asyncForEach = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(array, callback) {
    var index;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          index = 0;
        case 1:
          if (!(index < array.length)) {
            _context3.next = 7;
            break;
          }
          _context3.next = 4;
          return callback(array[index], index, array);
        case 4:
          index++;
          _context3.next = 1;
          break;
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _asyncForEach.apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/loopCommands.js
// module id = 4402
// module chunks = 11